// Grid size limitations
export const GRID_WIDTH = 8;
export const GRID_HEIGHT = 15;

export const gridTileSize = 62;
export const gridMarginX = (480 - 8 * 62) / 2;
export const gridMarginY = (960 - 15 * 62) / 2;

// Strafe behavior constants
export const STRAFE_CHANCE = 0.15;
export const STRAFE_COOLDOWN_TICKS = 200;

// Battle replay timing
export const MS_PER_TICK = 16; // ~60 ticks per second
export const TICKS_PER_SECOND = 60; // For DoT calculations
